import React from 'react';
import clsx from 'clsx';

import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';

import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';

import useStyles from './style';

const ErrorList = ({
  errorList = [],
  isExpanded = false,
  onToggleIcon = () => {},
}) => {
  const classes = useStyles();
  return (
    <>
      <div className='d-flex f-align-start f-justify-between w-100'>
        <div className='d-flex f-align-center'>
          <Typography variant='body2' className='color-error text-bold mr-2'>
            Errors Found
          </Typography>
          <IconButton onClick={onToggleIcon}>
            <ArrowDropDownIcon
              className={clsx('color-error', {
                [classes.showDetails]: isExpanded,
              })}
            />
          </IconButton>
        </div>
        {isExpanded && (
          <div>
            <Typography variant='body2' className='text-bold mr-6 mt-3'>
              Row Number
            </Typography>
          </div>
        )}
      </div>
      {isExpanded && (
        <div className={clsx('mt-2', classes.uploadWrapper)}>
          {errorList.map((error, index) => (
            <div className='d-flex f-justify-between'>
              <Typography
                key={index}
                variant='body2'
                className='color-error text-bold mr-4'
              >
                {error.message || ''}
              </Typography>
              <Typography
                key={index}
                variant='body2'
                className='text-bold mr-10'
              >
                {`${error.row || ''}`}
              </Typography>
            </div>
          ))}
        </div>
      )}
    </>
  );
};
export default ErrorList;
